import { render, staticRenderFns } from "./TosVersions.vue?vue&type=template&id=b8e6eee6&scoped=true"
import script from "./TosVersions.vue?vue&type=script&lang=js"
export * from "./TosVersions.vue?vue&type=script&lang=js"
import style0 from "./TosVersions.vue?vue&type=style&index=0&id=b8e6eee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e6eee6",
  null
  
)

export default component.exports